import { Dialog } from "primereact/dialog";
import DashboardSolicitacaoCompras from "../../../pages/solicitacoes/DashboardSolicitacaoCompras";
import DashboardLancamentoDespesa from "../../../pages/solicitacoes/DashboardLancamentoDespesa";
import DashboardMultas from "../../../pages/solicitacoes/DashboardMultas";
import RelatorioPromocoes from "../../../pages/solicitacoes/RelatorioPromocoes";
import RelatorioDesligamento from "../../../pages/solicitacoes/RelatorioDesligamento";
import RelatorioSolicitacaoPessoal from "../../../pages/solicitacoes/RelatorioSolicitacaoPessoal";
import RelatorioChamadoTI from "../../../pages/solicitacoes/RelatorioChamadoTI";
import RelatorioRecolhimentoAtivos from "../../../pages/solicitacoes/RelatorioRecolhimentoAtivos";
import RelatorioSolicitacaoAtivos from "../../../pages/solicitacoes/RelatorioSolicitacaoAtivos";
import RelatorioAnaliseLimitePrazo from "../../../pages/solicitacoes/RelatorioAnaliseLimitePrazo";
import RelatorioCadastroCliente from "../../../pages/solicitacoes/RelatorioCadastroCliente";
import RelatorioAjusteGtc from "../../../pages/solicitacoes/RelatorioAjusteGtc";
import RelatorioRenovacaoGdm from "../../../pages/solicitacoes/RelatorioRenovacaoGdm";
import { processoInfo } from "../../../utils/solicitacoes/processoRegistry";

const DASHBOARD_POR_PROCESSO = {
    SOLICITACAO_COMPRAS: DashboardSolicitacaoCompras,
    LANCAMENTO_DESPESA: DashboardLancamentoDespesa,
    PROCESSO_MULTAS: DashboardMultas,
    PROMOCAO_FUNCIONARIOS: RelatorioPromocoes,
    DESLIGAMENTO_PESSOAL: RelatorioDesligamento,
    SOLICITACAO_PESSOAL: RelatorioSolicitacaoPessoal,
    ABERTURA_CHAMADO_TI: RelatorioChamadoTI,
    RECOLHIMENTO_ATIVOS: RelatorioRecolhimentoAtivos,
    SOLICITACAO_ATIVOS: RelatorioSolicitacaoAtivos,
    ANALISE_LIMITE_PRAZO: RelatorioAnaliseLimitePrazo,
    CADASTRO_CLIENTE: RelatorioCadastroCliente,
    AJUSTE_GTC_ROTA_VISITA: RelatorioAjusteGtc,
    RENOVACAO_GDM: RelatorioRenovacaoGdm,
};

export function possuiDashboard(tipoProcesso) {
    return !!DASHBOARD_POR_PROCESSO[tipoProcesso];
}

export default function DashboardProcessoModal({ tipoProcesso, visible, onFechar }) {
    const Dashboard = DASHBOARD_POR_PROCESSO[tipoProcesso];
    if (!Dashboard) return null;

    return (
        <Dialog
            header={`Dashboard — ${processoInfo(tipoProcesso)?.label || tipoProcesso}`}
            visible={visible}
            onHide={onFechar}
            blockScroll
            maximizable
            className="w-[95vw] max-w-[1600px]"
            contentClassName="bg-background p-0"
        >
            {visible && <Dashboard />}
        </Dialog>
    );
}
